// Code taken from here with slight adaptations: https://github.com/axios/axios/blob/c4bf0a4afcac9a49e9b58d3ea64570110cba34f8/lib/utils.js
export const isArrayBuffer = kindOfTest('ArrayBuffer');
export const isBlob = kindOfTest('Blob');
export const isFile = kindOfTest('File');
export const isURLSearchParams = kindOfTest('URLSearchParams');
export function isArrayBufferView(val) {
    if (!isObject(val)) {
        return false;
    }
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) {
        return ArrayBuffer.isView(val);
    }
    else {
        return val && 'buffer' in val && isArrayBuffer(val.buffer);
    }
}
export function isBuffer(val) {
    return (isObject(val) &&
        typeof val !== 'undefined' &&
        val.constructor !== null &&
        isObject(val.constructor) &&
        'isBuffer' in val.constructor &&
        typeof val.constructor.isBuffer === 'function' &&
        val.constructor.isBuffer(val));
}
export function isFormData(thing) {
    const pattern = '[object FormData]';
    if (!isObject(thing)) {
        return false;
    }
    return ((typeof FormData === 'function' && thing instanceof FormData) ||
        toString.call(thing) === pattern ||
        (isFunction(thing.toString) && thing.toString() === pattern));
}
// Note: The <Readable|Writable>Stream interface does not have a `pipe` method. Keeping this behaviour to mitigate risks
export function isStream(val) {
    return isObject(val) && isFunction(val.pipe);
}
export function isObject(val) {
    return val !== null && typeof val === 'object';
}
export function forEach(obj, 
// eslint-disable-next-line @typescript-eslint/no-explicit-any
fn) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === 'undefined') {
        return;
    }
    // Force an array if not already something iterable
    if (typeof obj !== 'object') {
        /*eslint no-param-reassign:0*/
        obj = [obj];
    }
    if (Array.isArray(obj)) {
        // Iterate over array values
        for (let i = 0, l = obj.length; i < l; i++) {
            fn.call(null, obj[i], i, obj);
        }
    }
    else {
        // Iterate over object keys
        for (const key in obj) {
            if (Object.prototype.hasOwnProperty.call(obj, key)) {
                fn.call(null, obj[key], key, obj);
            }
        }
    }
}
const toString = Object.prototype.toString;
function isFunction(val) {
    return toString.call(val) === '[object Function]';
}
const kindOf = (function (cache) {
    return function (thing) {
        const str = toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    };
})(Object.create(null));
function kindOfTest(type) {
    type = type.toLowerCase();
    return function isKindOf(thing) {
        return kindOf(thing) === type;
    };
}
//# sourceMappingURL=utils.js.map